import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useHandleChangeHooks from "../../../../../hooks/digitalMarketing/useHandleChangeHooks";
import CustomInput from "../../../../../Component/DigitalMarketing/CustomInput";
import CustomVioletButton from "../../../../../Component/DigitalMarketing/CustomVioletButton";
import { useCreateReportMutation } from "../../../../../Service/PatientList";
import useSnackbar from "../../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../../Component/DigitalMarketing/Toast";

const AddReports = (props: any) => {
  const { setReportsModal, onSuccess } = props;
  const location = useLocation();
  const { id } = useParams();
  const { consultantId } = location.state || {};
  const { open, message, openSnackBar, type } = useSnackbar();

  const { formData, setFormData, handleChange, submit, setSubmit } =
    useHandleChangeHooks({});

  const [createReport, { isLoading }] = useCreateReportMutation();

  const categoryOptions = [
    { value: "Prescriptions", label: "Prescription" },
    { value: "receipts", label: "Receipt" },
    { value: "medical report", label: "Medical Report" },
    { value: "other", label: "Others" },
  ];

  const handleSubmit = async () => {
    setSubmit(true);

    if (
      !formData.reportTitle ||
      !formData.reportCategory ||
      !formData.fileUpload
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    const postformData = new FormData();
    postformData.append("reportTitle", formData.reportTitle);
    postformData.append("reportCategory", formData.reportCategory);
    postformData.append("fileUpload", formData.fileUpload);
    postformData.append("consultantId", consultantId);
    postformData.append("customerId", id);

    try {
      const res = await createReport(postformData).unwrap();
      openSnackBar(res?.message);

      setTimeout(() => {
        // Close modal
        setReportsModal(false);

        // Call parent callback if provided
        if (onSuccess) {
          onSuccess();
        }
      }, 500);
    } catch (err: any) {
      openSnackBar(
        err?.data?.message ||
          err?.data?.error ||
          "Failed to add report",
        "error"
      );
    }
  };

  return (
    <div>
      <Toast open={open} type={type} message={message} />
      <CustomInput
        {...formData}
        onChange={handleChange}
        type="text"
        label="Report Title"
        validation="required"
        submit={submit}
        name="reportTitle"
        setFormData={setFormData}
      />

      <CustomInput
        label="Category"
        type="select"
        option={categoryOptions}
        labelKey="label"
        valueKey="value"
        validation="required"
        submit={submit}
        {...formData}
        onChange={handleChange}
        name="reportCategory"
        setFormData={setFormData}
      />

      <CustomInput
        type="file"
        label="File"
        validation="required"
        submit={submit}
        {...formData}
        name="fileUpload"
        onChange={handleChange} // Ensure handleChange handles files
        setFormData={setFormData}
      />

      <div className="mt-3 d-flex justify-content-end">
        <CustomVioletButton
          btnLabel="Add Report"
          onClick={handleSubmit}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default AddReports;
